import {
  GraphQLList,
  GraphQLNonNull,
  GraphQLObjectType,
  GraphQLString
} from 'graphql'
import { Context } from '../shared'
import { ContrastGraphQLFieldConfig } from '../index'
import {
  applicationQueryArgs,
  ApplicationQueryArgs
} from '../types/application-query-args'
import { DateTime, dateTimeType } from '../types/date-time-type'

interface Browser {
  readonly agentName: string
  readonly agentVersion: string
  readonly timestamp: DateTime
}

const browser = new GraphQLObjectType({
  name: 'Browser',
  description: 'Application Browser data',
  fields: () => ({
    agentName: {
      type: new GraphQLNonNull(GraphQLString)
    },
    agentVersion: {
      type: new GraphQLNonNull(GraphQLString)
    },
    timestamp: {
      type: new GraphQLNonNull(dateTimeType)
    }
  })
})

interface ApplicationLiveArchitecture {
  readonly lastUpdate: DateTime
  readonly browsers: Browser[]
}

const applicationLiveArchitectureType = new GraphQLObjectType({
  name: 'ApplicationLiveArchitecture',
  fields: () => ({
    lastUpdate: {
      description: 'Application last activity update',
      type: new GraphQLNonNull(dateTimeType)
    },
    browsers: {
      description: 'Set of web browsers details',
      type: new GraphQLList(new GraphQLNonNull(browser))
    }
  })
})

export const applicationLiveArchitecture: ContrastGraphQLFieldConfig<
  any,
  Context,
  ApplicationQueryArgs,
  ApplicationLiveArchitecture
> = {
  description: 'Get live information for an application',
  type: new GraphQLNonNull(applicationLiveArchitectureType),
  args: applicationQueryArgs,
  async resolve(_source, args, context) {
    const { organizationID, applicationID } = args

    const response = await context.connector.get(
      `/${organizationID}/flowmap/${applicationID}/live`
    )

    return normalizeApplicationLiveArchitecture(response)
  }
}

export const normalizeApplicationLiveArchitecture = ({
  last_update: lastUpdate,
  browsers
}): ApplicationLiveArchitecture => ({
  lastUpdate,
  browsers: Array.isArray(browsers)
    ? browsers.map(({ agentName, agentVersion, timestamp }) => ({
        agentName,
        agentVersion,
        timestamp
      }))
    : []
})
